import demo from './clients/demo';
import development from './clients/development';
import { apiCalls, apiV1, apiV2 } from './apis/apis';
import { brp, ellyonsoft, mag, tobsa, mivasa, bmw } from './clients';

const removeKeywords = [
    'www.',
    'localhost.',
    '.io',
    '.com',
    'crm.',
    'https://',
    'http://',
    'local.',
    'staging.',
    '.warbox',
    'qa.',
];

const host = window.location.hostname.toLowerCase();

const siteName = removeKeywords.reduce((acc, keyword) => {
    return acc.replace(keyword, '');
}, host);

const CLIENTS = {
    ellyonsoft,
    demo,
    mag,
    brp,
    tobsa,
    mivasa,
    bmw,
    default: development,
};

const SELECTED_CLIENT = CLIENTS[siteName] ? CLIENTS[siteName] : CLIENTS.default;

const SITE_SETTINGS = {
    ...SELECTED_CLIENT,
    apiV1,
    apiV2,
    apiCalls,
};

export default SITE_SETTINGS;
